"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _lodash = _interopRequireDefault(require("lodash"));
var _SellerCartItems = require("../components/SellerCartItems");
var _SubscriptionItem = require("../components/SubscriptionItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GeneralStep = function GeneralStep(props) {
  var cartItemsBySellers = props.cartItemsBySellers,
    onUpdateQuantityOfCartItem = props.onUpdateQuantityOfCartItem,
    onDeleteCartItem = props.onDeleteCartItem,
    isSubscription = props.isSubscription;
  if (isSubscription) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      justifyContent: 'center',
      spacing: 2
    }, _lodash.default.map(cartItemsBySellers[0].items, function (cartItem, index) {
      return /*#__PURE__*/_react.default.createElement(_SubscriptionItem.SubscriptionItem, {
        key: index,
        cartItem: cartItem,
        onDelete: function onDelete() {
          return onDeleteCartItem(cartItem.id);
        }
      });
    }));
  }
  return _lodash.default.map(cartItemsBySellers, function (cartItemsBySeller) {
    var _cartItemsBySeller$se;
    return /*#__PURE__*/_react.default.createElement(_SellerCartItems.SellerCartItems, {
      key: cartItemsBySeller === null || cartItemsBySeller === void 0 ? void 0 : (_cartItemsBySeller$se = cartItemsBySeller.seller) === null || _cartItemsBySeller$se === void 0 ? void 0 : _cartItemsBySeller$se.id,
      seller: cartItemsBySeller === null || cartItemsBySeller === void 0 ? void 0 : cartItemsBySeller.seller,
      cartItems: cartItemsBySeller.items,
      onUpdateQuantityOfCartItem: onUpdateQuantityOfCartItem,
      onDeleteCartItem: onDeleteCartItem
    });
  });
};
exports.GeneralStep = GeneralStep;